/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Why_EyebrowInputs */

const en_coaches_page_why_eyebrow = /** @type {(inputs: Coaches_Page_Why_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why here`)
};

const pl_coaches_page_why_eyebrow = /** @type {(inputs: Coaches_Page_Why_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego tutaj`)
};

/**
* | output |
* | --- |
* | "Why here" |
*
* @param {Coaches_Page_Why_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_why_eyebrow = /** @type {((inputs?: Coaches_Page_Why_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Why_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_why_eyebrow(inputs)
	return en_coaches_page_why_eyebrow(inputs)
});